import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    standalone: true,
    name: 'shorten'
})

export class ShortenPipe implements PipeTransform {
    transform(value: string | null | undefined, limit: number) {
        if (typeof value !== 'string') return '';
        if (value && value.length > limit) {
            return value.substring(0, limit) + '...';
        }
        return value;
    }
}